@if (loading) {
  <app-loading-element class="loadingElementContainer componentBelow"></app-loading-element>
}
@if (!loading) {
<div  [ngClass]="theme.getThemeClass()"  class="container-fluid bg-light main-dashboard" style="background-color: rgb(255, 255, 255); height: 100%; margin-top: 5px;">

    <section [ngClass]="theme.getThemeClass()" class="dashboard-container row bg-light">
    <app-error-modal></app-error-modal>

    <!-- Section of different dashboard depend on user type -->
    @if (cognitoService.userType === 'operator') {<app-operator-dashboard></app-operator-dashboard>}
    @if (cognitoService.userType === 'muirwood') {<app-muirwood-dashboard></app-muirwood-dashboard>}
    @if (cognitoService.userType === 'client') {<app-client-dashboard></app-client-dashboard>}
    @if (cognitoService.userType === 'distributor') {<app-distributor-dashboard></app-distributor-dashboard>}
    </section>
</div>
}

